import {
  Box,
  Image,
  useStyleConfig,
  Button,
  Heading, List, Flex, Center, Text,
} from '@chakra-ui/react';
import { getUsefulVars } from '../../handlers/helpers';
import React, { useEffect } from 'react';
import { updateSectionData } from '../../handlers/utils';
import DownloadModal from '../../components/Modal/DownloadModal';
import { FaDownload } from 'react-icons/fa';
import { openPreview } from '../../components/Preview/utils';
import BorderBox from '../../components/Wrappers/BorderBox';
import MenuList from '../Menu/MenuList';
import MenuItem from './components/MenuItem';


const Interview = ({ props }) => {
  const uv = getUsefulVars(props);

  let imgSrc = uv.stateProps.domain + '/app/images/interview_coach.png';
  let title = 'AI Interview Coach';
  let heading = 'Nail the interview!';
  let text = 'Follow each step to answer questions about your past experience. Our AI interview\n' +
    '              coach will prepare accomplishment-based stories you can use to showcase your transferrable wins during\n' +
    '              interviews.'

  const sectionIndex = uv.stateProps.sectionData.sectionIndex;
  const menuSectionName = window.appType === 'city' ? 'menu-grow' : 'menu-interview';
  const sections = props.navSections[menuSectionName].sections;
  const navSections = props.navSections;
  if (window.appType === 'city') {
    imgSrc = uv.stateProps.domain + '/app/images/city_year_promo.png'
    title = 'City Year GROW Plan';
    heading= 'Create Your GROW Plan';
    text = 'The GROW Plan is a framework to help you reflect on your personal and professional development and prepare for ife after your service year. The steps you go through below will help you develop a clear plan to achieve your goals';
    uv.stateProps.setInterviewTitle('GROW Plan Goals');
  } else {
    uv.stateProps.setInterviewTitle('Interview Coach');
  }
  const variant = 'wrapper';
  const styles = {};
  styles.interview = useStyleConfig('Interview', { variant });
  styles.button = useStyleConfig('Button', { variant });

  useEffect(() => {
    if (sectionIndex !== 0) {
      updateSectionData({ sectionIndex: 0 }, uv.stateProps);
    }
  }, [sectionIndex]);
  let style = '';
  if(window.appType=== 'city') {
    style = 'width: "100%"';
  }
  return (
    <Box>
      <Box display="flex" justifyContent="space-between" width="100%">
        <Heading variant="section" pb={['32px', '32px', '40px']}>
          {title}
        </Heading>
      </Box>
      <BorderBox>
        <Box display="flex" justifyContent="space-evenly">
          {imgSrc !== '' && (
            <Center
              sx={{ width: '350px', overflow: 'hidden', margin: '0 -60px 0 0' }}
            >
              <Image
                sx={{
                  width: [0, 0, '400px'],
                  position: 'relative',
                  objectFit: 'contain',
                  zIndex: -1,
                  padding: '1rem 0',
                }}
                src={imgSrc}
              />
            </Center>
          )}
          <MenuList>
            <Heading fontSize="24px" marginBottom="-1rem !important">{heading}</Heading>
            <Text fontStyle="italic">{text}</Text>

            {Object.entries(navSections).map(([key, value]) => {
              return (
                sections.map((interview_menu_item, index) => {
                    if (interview_menu_item === key) {
                      const interviewMenuItem = navSections[interview_menu_item];
                      return (
                        <MenuItem
                          key={index}
                          props={props}
                          sectionTitle={interviewMenuItem.label}
                          sectionSubTitle={interviewMenuItem.instructions}
                          sectionName={interview_menu_item}
                        />
                      );
                    }
                  },
                )
              );
            })}
          </MenuList>
        </Box>
      </BorderBox>
    </Box>
  );

};

export default Interview;